var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.95 32.0702C22.47 32.0702 19.64 29.2402 19.64 25.7602C19.64 22.2802 22.47 19.4502 25.95 19.4502C29.43 19.4502 32.26 22.2802 32.26 25.7602C32.26 29.2402 29.43 32.0702 25.95 32.0702ZM25.95 21.3702C23.53 21.3702 21.56 23.3402 21.56 25.7602C21.56 28.1802 23.53 30.1502 25.95 30.1502C28.37 30.1502 30.34 28.1802 30.34 25.7602C30.34 23.3402 28.37 21.3702 25.95 21.3702Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.9401 39.1899C17.5901 39.1899 10.2401 33.8699 7.66006 25.9599L7.56006 25.6599L7.66006 25.3599C10.2501 17.4499 17.6001 12.1299 25.9401 12.1299C34.2801 12.1299 41.6601 17.4499 44.2501 25.3599L44.3501 25.6599L44.2501 25.9599C41.6601 33.8699 34.3101 39.1899 25.9401 39.1899ZM9.58006 25.6599C12.0001 32.6199 18.5301 37.2699 25.9401 37.2699C33.3501 37.2699 39.9101 32.6199 42.3201 25.6599C39.9101 18.6999 33.3601 14.0499 25.9401 14.0499C18.5201 14.0499 12.0001 18.6999 9.58006 25.6599Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.7495 34.892L8.74207 41.8994L10.0997 43.2571L17.1071 36.2496L15.7495 34.892Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.8987 8.74234L35.266 15.375L36.6236 16.7326L43.2563 10.1L41.8987 8.74234Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M45.26 11.49C42.64 11.49 40.51 9.36 40.51 6.75C40.51 4.14 42.64 2 45.26 2C47.88 2 50 4.13 50 6.75C50 9.37 47.87 11.49 45.26 11.49ZM45.26 3.92C43.7 3.92 42.43 5.19 42.43 6.75C42.43 8.31 43.7 9.57 45.26 9.57C46.82 9.57 48.08 8.3 48.08 6.75C48.08 5.2 46.81 3.92 45.26 3.92Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.74 50C4.12 50 2 47.87 2 45.26C2 42.65 4.13 40.52 6.74 40.52C9.35 40.52 11.49 42.65 11.49 45.26C11.49 47.87 9.36 50 6.74 50ZM6.74 42.43C5.18 42.43 3.92 43.7 3.92 45.25C3.92 46.8 5.19 48.07 6.74 48.07C8.29 48.07 9.57 46.8 9.57 45.25C9.57 43.7 8.3 42.43 6.74 42.43Z",
    fill: "#093640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.099 8.74392L8.74133 10.1016L15.7488 17.109L17.1064 15.7513L10.099 8.74392Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.6261 35.2649L35.2684 36.6226L41.9011 43.2552L43.2587 41.8976L36.6261 35.2649Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M45.26 50C42.64 50 40.51 47.87 40.51 45.26C40.51 42.65 42.64 40.52 45.26 40.52C47.88 40.52 50 42.65 50 45.26C50 47.87 47.87 50 45.26 50ZM45.26 42.43C43.7 42.43 42.43 43.7 42.43 45.25C42.43 46.8 43.7 48.07 45.26 48.07C46.82 48.07 48.08 46.8 48.08 45.25C48.08 43.7 46.81 42.43 45.26 42.43Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.74 11.49C4.13 11.49 2 9.36 2 6.75C2 4.14 4.13 2 6.74 2C9.35 2 11.49 4.13 11.49 6.75C11.49 9.37 9.36 11.49 6.74 11.49ZM6.74 3.92C5.18 3.92 3.92 5.19 3.92 6.75C3.92 8.31 5.19 9.57 6.74 9.57C8.29 9.57 9.57 8.3 9.57 6.75C9.57 5.2 8.3 3.92 6.74 3.92Z",
    fill: "#093640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlIcon);
export default __webpack_public_path__ + "static/media/control_icon.16923cffb2557d13762fcd9422ddb4be.svg";
export { ForwardRef as ReactComponent };